import { NavLink } from "react-router-dom";
import { cn } from "@/shared/lib/utils";
import { TEACHER_NAVIGATION } from "./teacher-navigation";

export interface TeacherBottomNavBarProps {
  className?: string;
}

/**
 * Floating bottom navigation bar matching Flutter's `TeacherBottomNavBar.dart`.
 * Renders an elevated pill with tinted active background, icon, and bold Persian title.
 */
export function TeacherBottomNavBar({ className }: TeacherBottomNavBarProps) {
  return (
    <nav
      aria-label="ناوبری اصلی پنل معلم"
      dir="rtl"
      className={cn(
        "pointer-events-none absolute right-0 bottom-4 left-0 z-20 flex justify-center px-4 select-none",
        className,
      )}
    >
      <div className="pointer-events-auto flex items-center justify-around gap-1 rounded-full border border-slate-200/90 bg-white/95 p-1.5 shadow-[0_8px_24px_rgba(0,0,0,0.1)] backdrop-blur-md">
        {TEACHER_NAVIGATION.map((tab) => {
          const Icon = tab.icon;

          return (
            <NavLink
              key={tab.id}
              to={tab.path}
              aria-label={tab.title}
              className={({ isActive }) =>
                cn(
                  "focus-visible:outline-brand flex h-10 items-center justify-center rounded-full px-3 transition-all duration-200 focus-visible:outline-2",
                  isActive
                    ? cn(
                        tab.activeBg,
                        tab.activeColor,
                        "border font-bold",
                        tab.activeBorder,
                      )
                    : "text-slate-500 hover:bg-slate-100/80 hover:text-slate-800",
                )
              }
            >
              {({ isActive }) => (
                <>
                  <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
                  {isActive && (
                    <span className="mr-1.5 text-xs tracking-tight">
                      {tab.title}
                    </span>
                  )}
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
